import { validate } from 'sha-el-design';

export const addCallHistoryMutation = `
mutation AddCallHistoryMutation($input: CallHistoryMutationInput!) {
  createCallHistory(input: $input) {
    id
  }
}
`;

export const addCallResponseMutationInput = `
mutation AddCallResponseMutationInput($input: CallResponseMutationInput!) {
  createCallResponse(input: $input) {
    id
  }
}
`;

export const questionnairesListQuery = `
query QuestionnairesListQuery($stateTown: String!, $after: String) {
  allQuestionnaires(stateTownFilter: $stateTown, after: $after, active: true) {
    pageInfo {
      hasNextPage
      endCursor
    }
    edges {
      node {
        id
        name
        openingStatement
        closingStatement
        addedBy {
          id
          employee {
            name
          }
        }
        allQuestions {
          id
          name
          questionType
          description
          options
        }
      }
    }
  }
}
`;

export interface CallResponse {
  questionResponse: Array<{
    questionId: string;
    response: string | string[];
  }>;
  order: Array<{
    productId: string;
    cases: number;
    pieces: number;
  }>;
  competitorPricing: Array<{
    brand: string;
    packing: string;
    rate: number;
  }>;
}

export const callResponseSchema = validate<CallResponse>(validate.Object({
  questionResponse: validate.Array(validate.Object({
    questionId: validate.Text(),
    response: validate.Text().required('Response is Required'),
  })),
  order: validate.Array(validate.Object({
    productId: validate.Text().required('Product is Required'),
    cases: validate.Text().required('Cases is Required'),
    pieces: validate.Text().required('Pieces is Required'),
  })),
  competitorPricing: validate.Array(validate.Object({
    brand: validate.Text().required('Brand is Required'),
    packing: validate.Text().required('Packing is Required'),
    rate: validate.Integer().required('Rate is Required'),
  })),
}));
